import { createContext } from "../../hooks/createContext";


export const [useFilterTextContext, FilterContextProvider] = createContext<string>()